import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlQueryNoneCnt(startTime, endTime) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_LINE_CHART_NONE, { startTime, endTime });

  // Возвращаем dataObjects - они уже имеют числовые индексы для обратной совместимости
  // element[0] = cnt, element[1] = data_hh
  return result.dataObjects;
}
